export default __webpack_public_path__ + "static/media/logo-dark.67cadf22.svg";